class BrowserStorage {
    constructor(rootKey = 'TESTING_ONLY_SESSION_DATA', options) {
        this.catchError = (func, ...args) => {
            delete this.lastError;
            try {
                return func(...args);
            }
            catch (e) {
                this.lastError = e;
            }
            return null;
        };
        // @ts-ignore
        this.getItem = () => this.catchError(() => this.options.deserialize(this.options.storage.getItem(this.options.rootKey)));
        // @ts-ignore
        this.setItem = (value) => this.catchError(() => this.options.storage.setItem(this.options.rootKey, this.options.serialize(value)));
        // @ts-ignore
        this.removeItem = () => this.catchError(() => this.options.storage.removeItem(this.options.rootKey));
        this.getLastError = () => this.lastError;
        this.options = Object.assign({ rootKey, storage: options.persist ? globalThis.localStorage : globalThis.sessionStorage, serialize: JSON.stringify, deserialize: JSON.parse }, options);
    }
}

const AUTH_UTILITY_ENVIRONMENT = 'AUTH_UTILITY_ENVIRONMENT';
const extractOptions = (paramValue = '') => {
    const options = {};
    const paramArray = (paramValue === null || paramValue === void 0 ? void 0 : paramValue.split('|')) || [];
    if (paramArray.length > 0) {
        if (paramArray[0]) {
            const env = String(paramArray[0]);
            options.env = env === null || env === void 0 ? void 0 : env.toUpperCase();
        }
        if (paramArray[1]) {
            options.version = paramArray[1];
        }
    }
    return options;
};
const getQueryOptions = () => {
    // Qstring Pattern -> auth_utility_environment=env|version
    // Example1: auth_utility_environment=PR|111
    // Example2: auth_utility_environment=|v0
    // Example3: auth_utility_environment=PROD
    var _a;
    let options = {};
    const browserStorage = new BrowserStorage(AUTH_UTILITY_ENVIRONMENT, { persist: true });
    const searchParams = new URLSearchParams((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _a === void 0 ? void 0 : _a.search);
    let paramValueString = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('auth_utility_environment')) || '';
    if (paramValueString) {
        options = extractOptions(paramValueString);
        browserStorage.setItem(paramValueString);
        return options;
    }
    // Check local storage
    paramValueString = browserStorage.getItem();
    if (paramValueString) {
        options = extractOptions(paramValueString);
    }
    return options;
};

const NONPROD = 'NONPROD';
const PROD = 'PROD';
/* */
const getEnvironment = () => {
    var _a;
    if ([
        'speedy.autotrader.com',
        'www.autotrader.com',
        'www.kbb.com',
        'www.fordblueadvantage.com',
        'specialty.autotrader.com',
        'classics.autotrader.com',
        'motorcycles.autotrader.com',
        'rvs.autotrader.com',
    ].includes((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _a === void 0 ? void 0 : _a.hostname)) {
        return PROD;
    }
    return NONPROD;
};

const DEFAULT_AUTH_UTILITY_VERSION = 'v1';

const isNumeric = (val) => /^\d+$/.test(val);

const getComponentURL = ({ env = getEnvironment(), version = DEFAULT_AUTH_UTILITY_VERSION }, entryPoint) => {
    const componentURL = {
        authUtilityURL: {
            PROD: `https://auth-dist.awscconsumerinfo.autotrader.com/prod/${version}/auth-utility.esm.js`,
            NONPROD: `https://auth-dist.awscconsumerinfonp.autotrader.com/nonprod/${version}/auth-utility.esm.js`,
            PR: `https://auth-dist.awscconsumerinfonp.autotrader.com/pr/${version}/auth-utility.esm.js`,
        },
        webComponentURL: {
            PROD: `https://auth-dist.awscconsumerinfo.autotrader.com/prod/${version}/cai-authentication-web-components.esm.js`,
            NONPROD: `https://auth-dist.awscconsumerinfonp.autotrader.com/nonprod/${version}/cai-authentication-web-components.esm.js`,
            PR: `https://auth-dist.awscconsumerinfonp.autotrader.com/pr/${version}/cai-authentication-web-components.esm.js`,
        },
    };
    return componentURL[entryPoint][env];
};
const getEsmModulePath = ({ env, version }, entryPoint = 'authUtilityURL') => {
    if (env === 'PR' && !isNumeric(version)) {
        throw new Error(`Version must be a number when env is set to 'PR'.`);
    }
    return getComponentURL({ env, version }, entryPoint);
};

// Run a build in the root folder to ensure this module exists.
//type ModuleType = typeof import('./auth-utility');
// TODO: uncomment line above and change return type of authUtilityLoader to Promise<ModuleType>
const authUtilityLoader = async (options = {}) => {
    if (typeof window === 'undefined') {
        throw new Error('auth-utility can only be loaded in a browser');
    }
    const SCRIPT_URL = getEsmModulePath(Object.assign(Object.assign({}, options), getQueryOptions()), 'authUtilityURL');
    return await import(/* webpackIgnore: true */ SCRIPT_URL);
};

const authUtilityURL = (options = {}) => getEsmModulePath(Object.assign(Object.assign({}, options), getQueryOptions()), 'authUtilityURL');

const authWebComponentURL = (options = {}) => getEsmModulePath(Object.assign(Object.assign({}, options), getQueryOptions()), 'webComponentURL');

export { authUtilityLoader, authUtilityURL, authWebComponentURL };
//# sourceMappingURL=index.mjs.map
